import { render, staticRenderFns } from "./indexyewubankuai.vue?vue&type=template&id=8d026070&scoped=true"
import script from "./indexyewubankuai.vue?vue&type=script&lang=js"
export * from "./indexyewubankuai.vue?vue&type=script&lang=js"
import style0 from "./indexyewubankuai.vue?vue&type=style&index=0&id=8d026070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d026070",
  null
  
)

export default component.exports